import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  variant: 'primary' | 'secondary';
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant,
  onClick,
  children,
  className = ''
}: ButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-xl font-bold transition-all duration-200 flex items-center justify-between gap-4 backdrop-blur-md';
  const variantStyles = {
    primary: 'bg-[#D4EDE4]/80 border-2 border-[#C8B84D] text-[#1B3A5C] hover:bg-white hover:shadow-lg shadow-md',
    secondary: 'bg-white/20 border border-white/40 text-white hover:bg-white/30 hover:shadow-lg'
  };
  // Extract text and icon from children if possible, or just render children
  // We want to force the chevron style for primary buttons as per screenshot
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${className}`} type="button" data-id="element-14">
      <span className="flex-1 text-left" data-id="element-15">{children}</span>
      {variant === 'primary' && <ChevronRight className="w-6 h-6 text-[#6B46C1] stroke-[3]" data-id="element-16" />}
    </button>;
}